module.exports = __webpack_public_path__ + "img/logosin.57d94cbf.png";